/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Success_ResetInputs */

const en_contact_form_success_reset = /** @type {(inputs: Contact_Form_Success_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send another message`)
};

const lv_contact_form_success_reset = /** @type {(inputs: Contact_Form_Success_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nosūtīt vēl vienu ziņu`)
};

/**
* | output |
* | --- |
* | "Send another message" |
*
* @param {Contact_Form_Success_ResetInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_success_reset = /** @type {((inputs?: Contact_Form_Success_ResetInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Success_ResetInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_success_reset(inputs)
	return en_contact_form_success_reset(inputs)
});